// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ed29ecb61048f437","4635":"831c205e5c7befec"}[chunkId] + ".css";
};